import http from '../http'

export default {
    /**
     * Consulta las solicitudes del usuario.
     * @param {int} usuario
     * @returns {Promise}
     */
    all(usuario) {
        return http.get(`usuarios/${usuario}/solicitudes`);
    },
}